import fetchLoyaltyAccount from 'actions/loyalty/fetchLoyaltyAccount'
import AuthRouteElement from 'components/App/Routes/AuthRouteElement'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useLocaleUrlOptions } from 'hooks/useLocaleUrlOptions'
import { buildUrl } from 'lib/url/searchUrlUtils'
import { LOYALTY_LANDING_PAGE } from 'loyalty/constants/loyaltyRoutes'
import getLoyaltyIsInfiniteAccountTier from 'loyalty/selectors/getLoyaltyIsInfiniteAccountTier'
import { useEffect } from 'react'
import type { ReactNode } from 'react'
import { selectLoggedIn } from 'selectors/accountSelectors'

interface Props {
  children?: ReactNode
  element?: ReactNode
  path: string
  showPopup?: boolean
  loader?: ReactNode
  accountAccessModalInitialMode?: App.UiAccountModalMode
}

function LoyaltyInfiniteMemberRoute(props: Props) {
  const {
    accountAccessModalInitialMode,
    children,
    element,
    loader,
    path,
    showPopup,
  } = props
  const isLoggedIn = useAppSelector(selectLoggedIn)

  if (!isLoggedIn) {
    return <>
      {element}
      {children}
    </>
  }

  return (
    <AuthRouteElement
      accountAccessModalInitialMode={accountAccessModalInitialMode}
      loader={loader}
      path={path}
      showPopup={showPopup}
    >
      <InfiniteMemberGuard>
        {element}
        {children}
      </InfiniteMemberGuard>
    </AuthRouteElement>
  )
}

function InfiniteMemberGuard(props: { children: ReactNode }) {
  const dispatch = useAppDispatch()
  const loyaltyAccount = useAppSelector(state => state.loyalty.account)
  const regionCode = useAppSelector(state => state.geo.currentRegionCode)
  const { locale, languageOptions } = useLocaleUrlOptions()
  const isInfiniteLoyaltyMember = useAppSelector(state => getLoyaltyIsInfiniteAccountTier(state))

  useEffect(() => {
    if (loyaltyAccount.initial && !loyaltyAccount.fetching) {
      dispatch(fetchLoyaltyAccount())
    }
  }, [dispatch, loyaltyAccount.fetching, loyaltyAccount.initial])

  useEffect(() => {
    if (!loyaltyAccount.initial && !loyaltyAccount.fetching && !isInfiniteLoyaltyMember) {
      window.location.assign(buildUrl(`/${LOYALTY_LANDING_PAGE}`, regionCode, undefined, undefined, {
        locale,
        languageOptions,
      }))
    }
  }, [isInfiniteLoyaltyMember, languageOptions, locale, loyaltyAccount.fetching, loyaltyAccount.initial, regionCode])

  if (loyaltyAccount.initial || loyaltyAccount.fetching) {
    return <LoadingIndicator />
  }

  if (!isInfiniteLoyaltyMember) {
    return <LoadingIndicator />
  }

  return <>{props.children}</>
}

export default LoyaltyInfiniteMemberRoute
